export default function InfoIcon(props) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="8" fill="#fff"/>
            <path fill="#0A81D1" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 3.5a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Zm1.8 8.2c0 .3-.2.4-.4.4H6.6a.4.4 0 0 1-.4-.4V11c0-.2.2-.4.4-.4H7v-2h-.4a.4.4 0 0 1-.4-.5v-.7c0-.3.2-.4.4-.4h2c.3 0 .4.1.4.4v3.2h.4c.2 0 .4.2.4.4v.7Z"/>
        </svg>
    )
}